import React, { useState } from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { comparisonRows } from '../../data/pricingComparison';
import { formatPrice, pricingPlans } from '../../data/pricingPlans';
type MobileComparisonProps = {
  planHref: (planId: string) => string;
  planCta: (planId: string) => string;
};
export function MobileComparison({
  planHref,
  planCta
}: MobileComparisonProps) {
  const [activeIndex, setActiveIndex] = useState(1);
  const plan = pricingPlans[activeIndex];
  return <div className="mt-8 lg:hidden" data-id="element-229" data-mp="2v079cszrilc3">
      <div role="tablist" aria-label="Choose a plan to compare" className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-230" data-mp="2v18r1gbaa62s">
        {pricingPlans.map((item, index) => {
        const isActive = index === activeIndex;
        return <button key={item.id} type="button" role="tab" aria-selected={isActive} onClick={() => setActiveIndex(index)} className={`rounded-lg border px-3 py-2.5 text-xs font-bold uppercase tracking-[0.06em] transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 ${isActive ? 'border-[#041F60] bg-[#041F60] text-white' : 'border-[#A6B6F8]/60 bg-white text-[#3A3A3A] hover:border-[#5B5299]'}`} data-id="element-231" data-mp="1empjpikezafr" data-mpi={index}>
              {item.name}
            </button>;
      })}
      </div>

      <div className="mt-6 rounded-2xl border border-[#A6B6F8]/60 bg-white" data-id="element-232" data-mp="1wulsdf4aplku">
        <div className="flex items-baseline justify-between gap-3 border-b border-[#A6B6F8]/50 px-5 py-4" data-id="element-233" data-mp="1i57i84swb04e">
          <div data-id="element-234" data-mp="1n40ww0jx4x65">
            <p className="text-xs font-bold uppercase tracking-[0.1em] text-[#5B5299]" data-id="element-235" data-mp="1n3r1fxg3txt2">
              {plan.name}
            </p>
            {plan.recommended && <p className="mt-1 text-xs font-bold text-[#041F60]" data-id="element-236" data-mp="196vjtglsey1e">
                Most popular
              </p>}
          </div>
          <p className="text-2xl font-bold tracking-tight text-[#041F60]" data-id="element-237" data-mp="3fttg9rqr0yii">
            {plan.priceLabel || formatPrice(plan.monthlyPrice)}
            <span className="text-xs font-semibold text-stone-500" data-id="element-238" data-mp="3azymtwlcd568"> / mo</span>
          </p>
        </div>

        <dl data-id="element-239" data-mp="360vpyzfim59c">
          {comparisonRows.map((row, index) => {
          const value = row.values[activeIndex];
          return <div key={row.feature} className="flex items-start justify-between gap-4 border-b border-[#A6B6F8]/30 px-5 py-3" style={{
            backgroundColor: index % 2 === 1 ? 'rgba(166,182,248,0.08)' : 'transparent'
          }} data-id="element-240" data-mp="2mroscffvtm6" data-mpi={index}>
                <dt className="text-sm leading-6 text-[#3A3A3A]" data-id="element-241" data-mp="3krctcobpn58v">
                  {row.feature}
                </dt>
                <dd className="shrink-0 pt-0.5 text-right" data-id="element-242" data-mp="2e9pniccbnvgw">
                  {value === true ? <>
                      <CheckIcon size={17} className="ml-auto text-[#5B5299]" aria-hidden="true" data-id="element-243" data-mp="oux51ze9mza9" />
                      <span className="sr-only" data-id="element-244" data-mp="xvd7r6n6q2e2">Included</span>
                    </> : value === false ? <>
                      <MinusIcon size={16} className="ml-auto text-stone-300" aria-hidden="true" data-id="element-245" data-mp="12mv75q9k7uwx" />
                      <span className="sr-only" data-id="element-246" data-mp="1ciy8itwl7pit">Not included</span>
                    </> : <span className="text-sm font-bold text-[#041F60]" data-id="element-247" data-mp="1hju9ozpk0xkj">
                      {value}
                    </span>}
                </dd>
              </div>;
        })}
        </dl>

        <div className="px-5 py-5" data-id="element-248" data-mp="3jd20p6ej53m9">
          <a href={planHref(plan.id)} className="flex items-center justify-center gap-2 rounded-lg bg-[#041F60] px-4 py-3 text-sm font-bold text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2" data-id="element-249" data-mp="3nbrdoxvnoj5d">
            {planCta(plan.id)}
          </a>
        </div>
      </div>
    </div>;
}